import PageTitleHook from '../../../utils/PageTitleHook/PageTitleHook';
import { Button, SectionalAlert } from '../../baseComponents';
import { useContext, useEffect, useState } from 'react';
import { pathContext, myAccountContext } from '../../../contexts/contexts';

export const BlockedService = () => {
  PageTitleHook('USCIS Online Account | Blocked Service');
  const { setUrl } = useContext(pathContext);
  const { user } = useContext(myAccountContext);
  const [spMessage, setSpMessage] = useState('');

  //We can use this to set SP message when user is redirected here
  useEffect(() => {
    setSpMessage(user.sp_message || 'Service is currently offline');
  }, [user.sp_message]);

  return (
    <div className="flex justify-center bg-white py-8 px-8">
      <div className="w-900" data-testid="blocked-service-container">
        <h1 className="text-3xl my-3 font-light text-dhs_font_gray">Please try again later...</h1>

        <br />
        <SectionalAlert type={'info'}>{spMessage}</SectionalAlert>
        <br />

        <Button id="2fa-back-btn" text="Back" type="primary" onClick={() => setUrl('/dashboard')} />
      </div>
    </div>
  );
};
